<template>
  <div class="stream-start-alert" v-if="stream">
    <div class="container">
      <div class="stream-start-alert__body">

        <div
          class="stream-start-alert__text"
          v-if="stream.status == 'prepare'">Старт нового потока {{ stream.date_start | moment("D MMMM") }}! Следите за нами!</div>

        <div
          class="stream-start-alert__text"
          v-if="stream.status == 'process'">Старт нового потока уже завтра! Успейте начать с нами!</div>

        <div class="stream-start-alert__icons">
          <a href="https://vk.com/perezagryzka_team" class="stream-start-alert__social-icon stream-start-alert__social-icon--vk" target="_blank">
            <img :src="staticBase+'images/vk-logo.svg'" alt="Вконтакте">
          </a>
          <a href="https://www.youtube.com/@PEREZAGRYZKA" class="stream-start-alert__social-icon stream-start-alert__social-icon--youtube" target="_blank">
            <img :src="staticBase+'images/youtube-logo.svg'" alt="YouTube">
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import {settings} from '../variables.js'


export default {

  name: 'StreamInvite',

  data () {
    return {
      staticBase: settings.staticBase,
      stream: null
    }
  },

  mounted () {
    axios.get("/lk/api/actual-stream/").then(response => {this.stream = response.data});
  }
}
</script>

<style lang="css" scoped>
</style>